export default {
  create: {
    title: 'Adicionar',
    subtitle: 'Jogos',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Jogo',
    button: {
      add: 'Novo jogo',
    },
  },
  list: {
    title: 'Shape Links',
    subtitle: 'Lista',
    add: 'Novo jogo',
  },
  card: {
    title: 'Shape Link',
    actions: 'Ações',
  },
  table: {
    title: 'Jogos Ativos',
    searchPlaceholder: 'Procurar por algo...',
  },
  form: {
    name: {
      label: 'Nome:',
      placeholder: 'Ex: Shape Link Nível 1',
      invalid: 'Nome é obrigatório',
    },
    showAnswer: {
      label: 'Mostrar resposta',
    },
    colored: {
      label: 'Colorido',
    },
    columns: {
      label: 'Colunas:',
    },
    rows: {
      label: 'Linhas:',
    },
    numPairs: {
      label: 'Quantidade de pares:',
      auto: 'Automático',
      tooltipAuto: 'Sugestão ideal: {count} pares para este grid.',
      tooltipManual: 'Defina a quantidade de pares manualmente.',
    },
    filled: {
      label: 'Estilo do preenchimento:',
      auto: 'Automático',
      filled: 'Sólido',
      outline: 'Contorno',
      tooltipWarning: "Mais de 9 pares: Preenchimento fixado em 'Automático'",
      tooltipInfo:
        'No modo Automático, o sistema alterna entre sólido e contorno para melhor legibilidade',
    },
    shapeMode: {
      label: 'Modo de representação:',
      geometric: 'Formas geométricas',
      number: 'Números',
    },
    pathWeight: {
      label: 'Espessura das Linhas:',
      thin: 'Fina',
      normal: 'Normal',
      bold: 'Espessa',
    },
    numberStyle: {
      label: 'Moldura do número:',
      plain: 'Somente número',
      circle: 'Círculo',
      square: 'Quadrado',
      rounded: 'Arredondado',
    },
  },
  button: {
    generate: 'Gerar Jogo',
  },
  sidebar: {
    exportHint: 'Você precisa salvar antes de exportar.',
    defaultFileName: 'shapelinks',
  },
  alert: {
    generated: 'Puzzle gerado com sucesso!',
    generateFailed: 'Falha ao gerar o puzzle. Tente aumentar os pares.',
    generateError: 'Erro na geração.',
    workerError: 'Erro interno nos workers.',
    gameSaved: 'Jogo salvo com sucesso!',
    workerErrors: {
      seedProductionFailed: 'Falha ao produzir sementes.',
      generationTimeout: 'Não foi possível gerar no tempo limite.',
    },
  },
};
